import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import { joinUrl } from "@utils/index";

export default class frpServerState extends baseState {
    // 列表
    @observable list = {};
    @action
    setList = data => {
        if (data.records) {
            data.records.forEach(e => {
                console.log(e);
                if (e.portRuleList) {
                    e.portRuleList = (e.portRuleList || []).join("\n");
                }
            });
        }

        this.list = data;
    };

    getList = data => this.fetch({ url: apiUrl.FRP_SERVER.LIST, method: 'get', setState: "setList", data });

    // 详情
    @observable detail = {};
    @action
    setDetail = data => this.detail = data;

    getDetail = ({ id }) => this.fetch({
        url: joinUrl(apiUrl.FRP_SERVER.DETAIL, id),
        method: 'get',
        setState: "setDetail",
        data: { id }
    });

    // 创建
    insert = data => {
        data.portRuleList = data.portRuleList.split("\n");
        return this.fetch({ url: apiUrl.FRP_SERVER.CREATE, method: 'post', data });
    };

    //编辑
    update = data => {
        data.portRuleList = data.portRuleList.split("\n");
        return this.fetch({ url: apiUrl.FRP_SERVER.UPDATE, method: 'post', data });
    }; // 更新

    // 空闲端口
    @observable freePortList = {};
    @action
    setFreePortList = data => this.freePortList = data;
    getFreePortList = data => this.fetch({
        url: apiUrl.FRP_SERVER.FREE_PORT_LIST.replace("{id}", data.id),
        method: 'get',
        setState: "setFreePortList",
        data
    });

    // 已占用端口
    @observable occupiedPortList = {};
    @action
    setOccupiedPortList = data => this.occupiedPortList = data;
    getOccupiedPortList = data => this.fetch({
        url: apiUrl.FRP_SERVER.OCCUPIED_PORT_LIST.replace("{id}", data.id),
        method: 'get',
        setState: "setOccupiedPortList",
        data
    });
}
